import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import { RebelTitle, RebelSubtitle } from '../../../styles/rebel-experiences';
import AgendaLocationForm from './agenda-location-form';

const AgendaConfigEdit = (props) => {
    const { id } = useParams();

    return (
        <PageContainer>
            <Row>
                <Col style={{textAlign: "center"}}>
                    <RebelTitle>
                        Edit Location
                    </RebelTitle>
                    <RebelSubtitle>
                        Configure location details and manage activities
                    </RebelSubtitle>
                </Col>
            </Row>

            <AgendaLocationForm id={id} />
        </PageContainer>
    )
}

export default AgendaConfigEdit;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;
